import { CreatePreAlertFeature } from "features";
import RootPage from "../RootPage";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import localisations from "../../shell/localisation";
import { reactPlugin } from "../../app-insights";
import { useAuth0 } from "@auth0/auth0-react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

function CreatePreAlertPage() {
    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.createPreAlert.heading}>
            <CreatePreAlertFeature fieldCompanyId={fieldCompanyId} />
        </RootPage>
    );
}

export default withAITracking(reactPlugin, CreatePreAlertPage, "Create Pre-Alert Page");
